// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBJI_giEa47dlNFDAoNX5Wa3qY3sLJV4xM',
    authDomain: 'cupboardchecker-f79f1.firebaseapp.com',
    databaseURL: 'https://cupboardchecker-f79f1-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'cupboardchecker-f79f1',
    storageBucket: 'cupboardchecker-f79f1.appspot.com',
    messagingSenderId: '109453977194',
    appId: '1:109453977194:web:af0b95fe0762aa705b8c13',
    measurementId: 'G-4K948GQEMV'
  },
  // Set to false to use real Firebase
  demoMode: false,
  // Stripe publishable key (safe to expose client-side). Price IDs are not
  // needed here — checkout sessions are created server-side via the
  // createCheckoutSession Cloud Function, which reads price IDs from
  // functions/.env.<project-id>.
  stripe: {
    publishableKey: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
